Ext.define('SA.data.DataMap', {
    constructor({country, observable = null}) {
        this.country = country;
        this.observable = observable;

        this.data = {};
        this.callbacks = new SA.data.CallbackSet();
        this.loadedLocations = {};
        this.loadedAttributes = {};
        this.derivedAttributes = {};

        this.purgeAttributes = SA.createBuffered(this.purgeAttributes, 10000);
    },

    autoEnsure({attributes, locations}) {
        var fn = this.autoEnsure.bind(this, {attributes, locations}); 

        this.ensure({attributes, locations, fn});
    },

    createQueryConfig(attributes, locationSeries) {
        var {country, derivedAttributes} = this;

        return SA.data.QueryConfig.create(country, locationSeries, attributes, derivedAttributes);
    },

    ensure(cfg) {
        var map = this.data,
            locations = cfg.locations,
            attributes = cfg.attributes.slice(),
            derived = cfg.derivedAttributes,
            loadedLocations = this.loadedLocations,
            loadedAttributes = this.loadedAttributes,
            derivedMap = this.derivedAttributes,
            missingLocations = [],
            missingAttributes = [],
            callbacks = this.callbacks,
            radiusLocation;

        locations.forEach(location => {
            var locationId = location.id;

            if (!map[locationId]) {
                map[locationId] = {locationSeries: locationId, details: location};
            }
        });

        if (this.activeQuery) {
            callbacks.add(cfg.fn, cfg.scope);
            return;
        }


        locations.forEach(location => {
            if (loadedLocations[location.id] == null) {
                if (location.type === 'radius') {
                    radiusLocation = radiusLocation || location;
                }
                else {
                    missingLocations.push(location);
                }
            }
        });

        if (missingLocations.length === 0 && radiusLocation) {
            missingLocations = [radiusLocation];
        }


        for (let attribute in derived) {
            attributes.push(attribute);

            let json = JSON.stringify(derived[attribute]);

            if (json !== JSON.stringify(derivedMap[attribute])) {
                delete loadedAttributes[attribute];

                derivedMap[attribute] = JSON.parse(json);
            }
        }

        attributes.forEach(attribute => {
            if (loadedAttributes[attribute] == null) {
                missingAttributes.push(attribute);
            }
        });


        if (missingLocations.length === 0) {
            for (let location in loadedLocations) {
                missingLocations.push(map[location].details);
            }
        }
        else if (!SA.Object.isEmpty(loadedAttributes)) {
            missingAttributes = [];

            for (let attribute in loadedAttributes) {
                missingAttributes.push(attribute);
            }
        }

        if (missingLocations.length === 0 || missingAttributes.length === 0) {
            return;
        }


        missingLocations.forEach(location => {
            loadedLocations[location.id] = loadedLocations[location.id] || false;
        });

        missingAttributes.forEach(attribute => {
            loadedAttributes[attribute] = loadedAttributes[attribute] || false;
        });

        this.run(missingLocations, missingAttributes);

        callbacks.add(cfg.fn, cfg.scope);
    },

    getData() {
        return this.data;
    },

    purgeAttributes() {
        var attributes = this.loadedAttributes,
            data = this.data;

        for (let location in data) {
            let entry = data[location];

            for (let attribute in entry) {
                if (attribute !== 'locationSeries' && attribute !== 'details' && attributes[attribute] == null) {
                    delete entry[attribute];
                }
            }
        }
    },

    removeAttribute(attribute) {
        delete this.loadedAttributes[attribute];
        delete this.derivedAttributes[attribute];

        this.purgeAttributes();
    },

    removeLocation(location) {


                delete this.data[location.id];
        delete this.loadedLocations[location.id];
    },

    run(locations, attributes) {
        if (!attributes.includes('locationSeries')) {
            attributes = ['locationSeries', ...attributes];
        }

        var loadedLocations = this.loadedLocations,
            loadedAttributes = this.loadedAttributes,
            query = this.createQueryConfig(attributes, locations);

        query = this.activeQuery = SA.data.Query.from(query);

        query.addFailure(() => {
            this.activeQuery = null;
        });

        query.addSuccess(rows => {
            var map = this.data;

            this.activeQuery = null;

            rows.forEach(row => {
                var entry = map[row.locationSeries];

                if (entry) {
                    Object.assign(entry, row);
                }
            });

            locations.forEach(location => {
                if (loadedLocations[location.id] === false) {
                    loadedLocations[location.id] = true;
                }
            });

            attributes.forEach(attribute => {
                if (loadedAttributes[attribute] === false) {
                    loadedAttributes[attribute] = true;
                }
            });

            this.callbacks.run();
            this.observable?.fireEvent('results');
        });

        query.run();
    }
});